<tg-row>
  <tg-col md="9" sm="12">
    <tg-row>
      @if (!isSummaryStep) {
        <tg-col md="6" sm="12">
          <button tgButton2 tgStyle="primary" (click)="onContinueTo()" class="motors-footer__margin-right" [disabled]="photosUploading$ | async">
            Continue to {{ continueToTitle$ | async }}
          </button>
          @if (!isEditOrRelistPage) {
<tm-start-over-button [disabled]="
                    (listingActionLoading$ | async) ||
                    (listingActionResponse$ | async)?.success">
            </tm-start-over-button>
          }
        </tg-col>
      }

      @if (isSummaryStep && isEditOrRelistPage) {
        <tg-col md="6" sm="12"
          class="motors-footer__summary-save-change">
          <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
            class="motors-footer__summary-topup--button"
            [disabled]="(listingActionLoading$ | async) || (listingActionResponse$ | async)?.success">
            Top up my account
          </button>
          @if (isRelistPage) {
            <button tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'"
                    class="motors-footer__summary-create-listing--button" (click)="onEditOrRelistListing()" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success" [tgLoading]="listingActionLoading$ | async">
              Start my listing
            </button>
          }
          @if (isEditPage) {
            <button (click)="onEditOrRelistListing()" tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'"
                    class="motors-footer__summary-topup--button" [disabled]="
                        !createOrEditOrRelistListingEnabled ||
                        (listingActionLoading$ | async) ||
                        (listingActionResponse$ | async)?.success" [tgLoading]="listingActionLoading$ | async">
              Update my listing
            </button>
          }
        </tg-col>
      }

      @if (isSummaryStep && !isEditOrRelistPage) {
        <tg-col md="6" sm="12" class="motors-footer__summary-topup">
          <button tgButton2 [tgStyle]="shouldTopUp ? 'primary' : 'secondary'" (click)="onShowTopUpModal(true)"
                    class="motors-footer__summary-topup--button" [disabled]="
                  (listingActionLoading$ | async) ||
                  (listingActionResponse$ | async)?.success">
            Top up my account
          </button>
          <button tgButton2 [tgStyle]="shouldTopUp ? 'secondary' : 'primary'" class="motors-footer__summary-create-listing--button"
            (click)="onCreateListing()" [disabled]="!createOrEditOrRelistListingEnabled"
            [tgLoading]="listingActionLoading$ | async">
            Start my listing
          </button>
        </tg-col>
      }

      @if (!isEditOrRelistPage) {
        <tg-col md="4" sm="12"
          [ngClass]="{'motors-footer__save-and-exit--centre': isCompact}">
          <button tgButton2 linkStyle class="motors-footer__save-and-exit" (click)="onSaveAndExit()" [disabled]="photosUploading$ | async">
            Save and exit
          </button>
        </tg-col>
      }
    </tg-row>
  </tg-col>
</tg-row>

@if (isCreditAccountModalVisible) {
  <tg-modal (close)="onShowTopUpModal(false)"
    class="motors-page-footer__credit-account-modal" fullscreen>
    <tmm-credit-account (cancelled)="onShowTopUpModal(false)" (creditAdded)="onCreditAdded()"
      (topupFailed)="onCreditFailure()">
    </tmm-credit-account>
  </tg-modal>
}
